/*
 * PureEatiz — subtle scroll-in animations.
 * Headings/copy fade up, cards fade up with a small stagger, large images ease in with a tiny zoom.
 * Skipped for reduced-motion users, inside the theme editor, and for the first section (hero / LCP).
 * After an element has revealed, its reveal attributes are removed so its own hover effects work normally.
 */
(function () {
  if (window.peRevealInit) return;
  window.peRevealInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  if (reduced || designMode || !('IntersectionObserver' in window)) return;

  var GROUPS = {
    up: [
      '.pe-section-head',
      '.pe-story__content',
      '.pe-split__content',
      '.pe-pd__content',
      '.pe-ps__copy',
      '.pe-blog-featured__content',
      '.pe-rich-text__inner',
      '.pe-newsletter__row',
      '.pe-sc-row__content'
    ],
    stagger: [
      '.pe-pcard',
      '.pe-acard',
      '.pe-journal-card',
      '.pe-recipe-card',
      '.pe-rowcard',
      '.pe-steps__item',
      '.pe-stats__item',
      '.pe-review',
      '.pe-features__col',
      '.pe-icon-grid__item',
      '.pe-recipe-stats__item',
      '.pe-recipe-nutrition__item',
      '.pe-recipe-bento__card',
      '.pe-faq__item',
      '.pe-pd__item'
    ],
    zoom: [
      '.pe-story__media',
      '.pe-split__media--plain',
      '.pe-pd__media',
      '.pe-ps__media',
      '.pe-blog-featured__media',
      '.pe-features__media',
      '.pe-recipe-product__card',
      '.pe-sc-row__media'
    ]
  };

  function firstSection() {
    return document.querySelector('#MainContent > .shopify-section');
  }

  // Cards in a horizontal scroller (mobile product range, carousels) must not be hidden by the reveal:
  // the next card only peeks in from the edge, so it never reaches the observer's 8% visibility and
  // would stay invisible until the shopper scrolled the row.
  function inHorizontalScroller(el) {
    // Only look inside the section: the page wrapper itself has overflow-x: auto.
    for (var p = el.parentElement; p && !p.classList.contains('shopify-section') && p !== document.body; p = p.parentElement) {
      var overflowX = window.getComputedStyle(p).overflowX;
      if (overflowX === 'auto' || overflowX === 'scroll') return true;
    }
    return false;
  }

  function init() {
    var skip = firstSection();
    var items = [];

    Object.keys(GROUPS).forEach(function (kind) {
      document.querySelectorAll(GROUPS[kind].join(',')).forEach(function (el) {
        if (el.hasAttribute('data-pe-reveal') || (skip && skip.contains(el))) return;
        if (kind === 'stagger' && inHorizontalScroller(el)) return;
        var type = kind === 'zoom' ? 'zoom' : 'up';
        el.setAttribute('data-pe-reveal', type);
        if (kind === 'stagger' && el.parentElement) {
          var siblings = Array.prototype.filter.call(el.parentElement.children, function (child) {
            return child.hasAttribute('data-pe-reveal');
          });
          var index = siblings.indexOf(el);
          el.style.setProperty('--pe-reveal-delay', Math.min(index, 5) * 80 + 'ms');
        }
        items.push(el);
      });
    });

    if (!items.length) return;
    document.documentElement.classList.add('pe-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          el.classList.add('is-revealed');
          var delay = parseInt(el.style.getPropertyValue('--pe-reveal-delay') || '0', 10);
          window.setTimeout(function () {
            el.removeAttribute('data-pe-reveal');
            el.classList.remove('is-revealed');
            el.style.removeProperty('--pe-reveal-delay');
          }, 900 + delay);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
